import apiRequest from "../services/request";

const POST = "POST",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  URLENCODED = "urlencoded",
  FORMDATA = "formdata",
  JSONDATA = "json";

export default {
  // --- AUTH ---
  login: (data) => apiRequest(POST, "/api/auth/login", data, URLENCODED),
  logout: () => apiRequest(POST, "/api/auth/logout"),

  // --- PERSONAL ---
  me: () => apiRequest(GET, "/api/users/me"),
  update_profile: (data) =>
    apiRequest(PUT, "/api/users/me/profile", data, JSONDATA),
  change_password: (data) =>
    apiRequest(PUT, "/api/users/me/password", data, JSONDATA),
  my_audit_logs: () => apiRequest(GET, "/api/users/me/audit-logs"),

  // --- UPLOAD ---
  upload_image: (formData) =>
    apiRequest(POST, "/api/uploads/image", formData, FORMDATA),

  // --- DASHBOARD ---
  general: () => apiRequest(GET, "/api/dash/"),

  // AUDIT
  audit_list: (params) => apiRequest(GET, "/api/audit", params),

  // --- USERS ---
  users_list: (params) => apiRequest(GET, "/api/users", params),
  users_create: (data) => apiRequest(POST, "/api/users", data, JSONDATA),
  users_update: (id, data) =>
    apiRequest(PUT, `/api/users/${id}`, data, JSONDATA),
  users_toggle_active: (id) =>
    apiRequest(PATCH, `/api/users/${id}/toggle-active`),

  // Issuer
  issuers_list: (params) => apiRequest(GET, "/api/issuers", params),
  issuers_create: (data) => apiRequest(POST, "/api/issuers", data, JSONDATA),
  issuers_update: (id, data) =>
    apiRequest(PATCH, `/api/issuers/${id}`, data, JSONDATA),
  issuers_delete: (id) => apiRequest(DELETE, `/api/issuers/${id}`),

  // Category
  categories_list: (params) => apiRequest(GET, "/api/categories", params),
  categories_create: (data) =>
    apiRequest(POST, "/api/categories", data, JSONDATA),
  categories_update: (id, data) =>
    apiRequest(PATCH, `/api/categories/${id}`, data, JSONDATA),
  categories_delete: (id) => apiRequest(DELETE, `/api/categories/${id}`),

  // Card
  cards_list: (params) => apiRequest(GET, "/api/cards", params),
  cards_detail: (id) => apiRequest(GET, `/api/cards/${id}`),
  cards_create: (data) => apiRequest(POST, "/api/cards", data, JSONDATA),
  cards_update: (id, data) =>
    apiRequest(PATCH, `/api/cards/${id}`, data, JSONDATA),
  cards_delete: (id) => apiRequest(DELETE, `/api/cards/${id}`),

  // Loan
  loans_list: (params) => apiRequest(GET, "/api/loans", params),
  loans_detail: (id) => apiRequest(GET, `/api/loans/${id}`),
  loans_create: (data) => apiRequest(POST, "/api/loans", data, JSONDATA),
  loans_update: (id, data) =>
    apiRequest(PATCH, `/api/loans/${id}`, data, JSONDATA),
  loans_delete: (id) => apiRequest(DELETE, `/api/loans/${id}`),

  // Savings
  savings_list: (params) => apiRequest(GET, "/api/savings", params),
  savings_detail: (id) => apiRequest(GET, `/api/savings/${id}`),
  savings_create: (data) => apiRequest(POST, "/api/savings", data, JSONDATA),
  savings_update: (id, data) =>
    apiRequest(PATCH, `/api/savings/${id}`, data, JSONDATA),
  savings_delete: (id) => apiRequest(DELETE, `/api/savings/${id}`),

  // api.js-д нэмэх
  insurances_list: (params) => apiRequest(GET, "/api/insurances", params),
  insurances_detail: (id) => apiRequest(GET, `/api/insurances/${id}`),
  insurances_create: (data) => apiRequest(POST, "/api/insurances", data),
  insurances_update: (id, data) =>
    apiRequest(PATCH, `/api/insurances/${id}`, data),
  insurances_delete: (id) => apiRequest(DELETE, `/api/insurances/${id}`),

  // Apartment
  apartments_list: (params) => apiRequest(GET, "/api/apartments", params),
  apartments_detail: (id) => apiRequest(GET, `/api/apartments/${id}`),
  apartments_create: (data) => apiRequest(POST, "/api/apartments", data),
  apartments_update: (id, data) =>
    apiRequest(PATCH, `/api/apartments/${id}`, data),
  apartments_delete: (id) => apiRequest(DELETE, `/api/apartments/${id}`),

  // ── Promotions ───────────────────────────────────────────────
  promotions_list: (params) => apiRequest(GET, "/api/promotions", params),
  promotions_create: (data) =>
    apiRequest(POST, "/api/promotions", data, JSONDATA),
  promotions_update: (id, data) =>
    apiRequest(PATCH, `/api/promotions/${id}`, data, JSONDATA),
  promotions_cancel: (id, data) =>
    apiRequest(PATCH, `/api/promotions/${id}/cancel`, data, JSONDATA),
  promotions_delete: (id) => apiRequest(DELETE, `/api/promotions/${id}`),

  // Upload
  upload_image: (formData) =>
    apiRequest(POST, "/api/upload/image", formData, FORMDATA),

  // Media list (серверээс бүх зургийн жагсаалт)
  media_list: () => apiRequest(GET, "/api/upload/media"),

  // News Taxonomy
  news_taxonomies_list: (params) =>
    apiRequest(GET, "/api/news-taxonomies", params),
  news_taxonomies_create: (data) =>
    apiRequest(POST, "/api/news-taxonomies", data, JSONDATA),
  news_taxonomies_update: (id, data) =>
    apiRequest(PATCH, `/api/news-taxonomies/${id}`, data, JSONDATA),
  news_taxonomies_delete: (id) =>
    apiRequest(DELETE, `/api/news-taxonomies/${id}`),

  // NEWS
  news_list: (params) => apiRequest(GET, "/api/news", params),
  news_detail: (slug) => apiRequest(GET, `/api/news/${slug}`),
  news_create_draft: () => apiRequest(POST, "/api/news/draft"),
  news_update: (slug, data) =>
    apiRequest(PATCH, `/api/news/${slug}`, data, JSONDATA),
  news_delete: (slug) => apiRequest(DELETE, `/api/news/${slug}`),

  // DASH
  dash: () => apiRequest(GET, "/api/dash"),

  // BANNER
  banners_list: (params) => apiRequest(GET, "/api/banners", { params }),
  banners_create: (data) => apiRequest(POST, "/api/banners", data, JSONDATA),
  banner_update: (id, data) =>
    apiRequest(PATCH, `/api/banners/${id}`, data, JSONDATA),
  banner_delete: (id) => apiRequest(DELETE, `/api/banners/${id}`),
  banner_reorder: (data) =>
    apiRequest(PATCH, "/api/banners/reorder", data, JSONDATA),

  // ── Keywords ──
  keywords_list: () => apiRequest(GET, "/api/keywords"),
  keywords_create: (data) => apiRequest(POST, "/api/keywords", data),
  keywords_update: (id, data) => apiRequest(PATCH, `/api/keywords/${id}`, data),
  keywords_remove: (id) => apiRequest(DELETE, `/api/keywords/${id}`),
};
